import { produce } from "immer";

export const appEvents = {
  CHANGEMODE: "changemode",
  UPDATEIMAGES: "updateimages",
  UPDATEIMPORT: "updateimport",
  UPDATEMODE: "updatemode"
};

const appReducer = (state, action) => {
  switch (action.type) {
    case appEvents.CHANGEMODE:
      return produce(state, (draft) => {
        draft.mode = action.payload;
      });
    case appEvents.UPDATEIMPORT:
      return produce(state, (draft) => {
        draft.importer = {
          ...draft.importer,
          ...action.payload
        };
      });
    case appEvents.UPDATEMODE:
      return produce(state, (draft) => {
        draft.mode = action.payload;
      });
    case appEvents.UPDATEIMAGES:
      return produce(state, (draft) => {
        draft.images = action.payload;
      });
    default:
      return state;
  }
};

export default appReducer;
